export class MeasuringEquipment {

    public id: number;
    public name: string;
    public description: string;

    constructor(measuringEquipment: any = {}) {
        this.id = measuringEquipment.id || null;
        this.name = measuringEquipment.name || '';
        this.description = measuringEquipment.description || '';
    }
}
